"use client";
//#region packages/@mantine/core/src/components/Combobox/get-options-lockup/get-options-lockup.ts
function getOptionsLockup(options) {
	return options.reduce((acc, item) => {
		if ("group" in item) return {
			...acc,
			...getOptionsLockup(item.items)
		};
		acc[`${item.value}`] = item;
		return acc;
	}, {});
}
//#endregion
export { getOptionsLockup };

//# sourceMappingURL=get-options-lockup.mjs.map